import { Flex, Text } from '@tremor/react';
import s from '@/components/layouts/Modals/UserProfileModal/UserProfileModal.module.scss';
import { useState } from 'react';
import { useRevalidator } from 'react-router-dom';
import { EntityType } from '@/types/Organization';
import { useUserPermissionsStore } from '@/stores/userPermissionsStore';
import { OutlinedButton } from '../../Buttons/OutlinedButton/OutlinedButton';

interface Props {
  invitationId: string;
  workspaceName: string;
  onAcceptInvitation: (
    workspaceId: string,
    invitationId: string,
    userId: string,
    entityType: EntityType,
  ) => Promise<void>;
  onDeleteInvitation: (
    workspaceId: string,
    invitationId: string,
    entityType: EntityType,
  ) => Promise<void>;
  workspaceId: string;
  entityType: EntityType;
}

export function UserInvitation({
  invitationId,
  workspaceName,
  workspaceId,
  onDeleteInvitation,
  onAcceptInvitation,
  entityType,
}: Props) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
  const userId = useUserPermissionsStore((state) => state.userId);
  const revalidator = useRevalidator();

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onDeleteInvitation(workspaceId, invitationId, entityType);
      revalidator.revalidate();
    } catch (e) {
      console.error(e);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleAccept = async () => {
    setIsAccepting(true);
    try {
      await onAcceptInvitation(workspaceId, invitationId, userId as string, entityType);
      revalidator.revalidate();
    } catch (e) {
      console.error(e);
    } finally {
      setIsAccepting(false);
    }
  };

  return (
    <Flex justifyContent="between" style={{ width: '100%' }}>
      <Text className={s.workspaceNameText}>{workspaceName}</Text>
      <Flex justifyContent="end">
        <OutlinedButton
          isLoading={isAccepting}
          onClick={async () => handleAccept()}
          spinnerSize="20px"
          spinnerColor="#BA2634"
        >
          Accept
        </OutlinedButton>
        <OutlinedButton
          isLoading={isDeleting}
          className={s.startDeleteButton}
          style={{ marginLeft: '10px' }}
          onClick={handleDelete}
          spinnerSize="20px"
          spinnerColor="red"
        >
          Delete
        </OutlinedButton>
      </Flex>
    </Flex>
  );
}
